import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { StatusBar } from 'components/common/StatusBar'
import { useIgoPoolInfo } from '../../hooks/usePoolInfo'
import Loading from '../../components/common/Loading'
import { formatUnits } from 'ethers/lib/utils'
import { useXVipLevel } from '../../hooks/useVipLevel'
import useIGOStage, { IGOStage } from '../../hooks/useIGOStage'
import useUserRaised from '../../hooks/useUserRaised'
import { imgBaseUrl } from '../../utils/constant'
import { IGO, useIGOList } from '../../hooks/useIGOList'

export default function MyIgo() {
  const { list, loading } = useIGOList(3)

  return (
    <MyIGOWrapper>
      {loading ? <Loading height={100} /> : list.map((item, key) => <IGOItem key={key} baseInfo={item} />)}
    </MyIGOWrapper>
  )
}

const MyIGOWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 40px;
`

function IGOItem({ baseInfo }: { baseInfo: IGO }) {
  const poolInfo = useIgoPoolInfo(baseInfo.sale_contract)
  const stage = useIGOStage(poolInfo)
  const raised = useUserRaised(poolInfo?.address)
  const xLevel = useXVipLevel(poolInfo?.address)

  if (!raised) return null

  return (
    <IGOItemWrapper>
      {!poolInfo ? (
        <Loading height={127} />
      ) : (
        <>
          <CountDownWrapper>
            <CountDown>{/*Countdown: <span>0 D : 2 H : 50 M: 13 S</span>*/}</CountDown>
          </CountDownWrapper>
          <Line />
          <ItemContentWrapper>
            <Avatar src={imgBaseUrl + baseInfo?.token_logo} />
            <Name>{baseInfo?.title}</Name>
            <AttrWrapper>
              <span>Status</span>
              <span>
                {stage <= IGOStage.Draw
                  ? 'In progress'
                  : stage === IGOStage.DrawIn
                  ? 'Won the lottery'
                  : 'Missed out the lottery'}
              </span>
            </AttrWrapper>
            <AttrWrapper>
              <span>Amount Purchased</span>
              <span>
                {+formatUnits(poolInfo?.oneSharePrice, poolInfo.costToken.decimals)} {poolInfo.costToken.symbol}
              </span>
            </AttrWrapper>
            <AttrWrapper>
              <span>Anticipated Token</span>
              <span>
                {stage === IGOStage.DrawOut
                  ? '--'
                  : +formatUnits(poolInfo.oneShareAmount, poolInfo.targetToken.decimals)}
                {poolInfo.targetToken.symbol}
              </span>
            </AttrWrapper>
            <AttrWrapper>
              <span>VIP Level </span>
              <span>Level-{xLevel}</span>
            </AttrWrapper>
            {/* {false && <Details to={`/myigo-detail?id=${baseInfo?.id}`}>Details &gt;&gt;</Details>} */}
            <Link to={`/myigo-detail?id=${baseInfo?.id}`}>
              <StyledStatusBar>Details &gt;&gt;</StyledStatusBar>
            </Link>
          </ItemContentWrapper>
        </>
      )}
    </IGOItemWrapper>
  )
}

const IGOItemWrapper = styled.div`
  display: block;
  height: 167px;
  width: 100%;
  border-radius: 20px;
  background: #11388c;
  padding: 20px 30px;
  margin-bottom: 20px;
`

const CountDownWrapper = styled.div`
  height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const CountDown = styled.p`
  width: 300px;
  line-height: 20px;
  font-size: 13px;
  color: #6090f8;

  span {
    color: #fff;
    margin-left: 10px;
  }
`

// const Details = styled(Link)`
//   color: #00f4e4;
//   font-size: 13px;
// `

const Line = styled.div`
  height: 1px;
  width: 100%;
  margin: 22px 0 30px 0;
  background: #09438e;
`

const ItemContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 62px 218px 197px 162px 178px 149px 114px;
  align-items: center;
  justify-items: start;
  justify-content: space-between;
  align-items: center;
`

const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`
const Name = styled.span`
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  line-height: 25px;
`

const AttrWrapper = styled.div`
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  span:first-child {
    font-size: 12px;
    color: #6090f8;
    line-height: 17px;
  }

  span:last-child {
    font-size: 14px;
    color: #fff;
    line-height: 20px;
  }
`
const StyledStatusBar = styled(StatusBar)`
  width: 114px;
`
